import { decrypt, encrypt } from "./EncryptionService";

const ID_TOKEN_KEY = "id_token" as string;
const ID_USER_KEY = "id_user" as string;
const ID_LANG_KEY = "id_lang" as string;
const ID_CREDENTIALS_KEY = "u_cred" as string;
const ID_TIME_ZONE_KEY = "u_tz" as string;

export const getCredentials = (): any | null => {
  const encryptedCredentials = window.localStorage.getItem(ID_CREDENTIALS_KEY)
  if (encryptedCredentials) {
    return JSON.parse(decrypt(encryptedCredentials));
  }
  return null
};

export const saveCredentials = (credentials: any): void => {
  const encryptedCredentials = encrypt(JSON.stringify(credentials));
  window.localStorage.setItem(ID_CREDENTIALS_KEY, encryptedCredentials);
};

export const destroyCredentials = (): void => {
  window.localStorage.removeItem(ID_CREDENTIALS_KEY);
};

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  const encryptedToken = window.localStorage.getItem(ID_TOKEN_KEY)
  if (encryptedToken) {
    return decrypt(encryptedToken);
  }
  return null
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  const encryptedToken = encrypt(token);
  window.localStorage.setItem(ID_TOKEN_KEY, encryptedToken);
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

/**
 * @description get token form localStorage
 */
export const getLanguage = (): string | null => {
  return window.localStorage.getItem(ID_LANG_KEY);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveLanguage = (langCode: string): void => {
  window.localStorage.setItem(ID_LANG_KEY, langCode);
};

/**
 * @description remove token form localStorage
 */
export const destroyLanguage = (): void => {
  window.localStorage.removeItem(ID_LANG_KEY);
};

/**
 * @description get user form localStorage
 */
export const getUser = (): any | null => {
  const encryptedUser = window.localStorage.getItem(ID_USER_KEY);
  if (encryptedUser) {
    const userJson = decrypt(encryptedUser)
    if (userJson) {
      return JSON.parse(userJson);
    }
  }
  return null
};

export const getUserHubGroupKey = (): string | null => {
  const user = getUser();
  if (user) {
    if (user.companyId)
      return user.companyId;

    if (user.id)
      return user.id;
  }

  return null;
}

/**
 * @description save user into localStorage
 * @param token: string
 */
export const saveUser = (user: any): void => {
  const userJson = JSON.stringify(user)
  const encryptedUser = encrypt(userJson)
  window.localStorage.setItem(ID_USER_KEY, encryptedUser);
};

/**
 * @description save user into localStorage
 * @param token: string
 */
export const destroyUser = (): void => {
  window.localStorage.removeItem(ID_USER_KEY);
};

/**
 * @description save time zone into localStorage
 * @param token: string
 */
export const saveTimeZone = (timeZone: string): void => {
  if (timeZone) {
    const encryptedTimeZone = encrypt(timeZone)
    window.localStorage.setItem(ID_TIME_ZONE_KEY, encryptedTimeZone);
  }
};

/**
 * @description get time zone from localStorage
 * @param token: string
 */
export const getTimeZone = (): string | null => {
  const encryptedTimeZone = window.localStorage.getItem(ID_TIME_ZONE_KEY);
  if (encryptedTimeZone) {
    return decrypt(encryptedTimeZone)
  }

  return null
};

/**
 * @description save time zone into localStorage
 * @param token: string
 */
export const destroyTimeZone = (): void => {
  window.localStorage.removeItem(ID_TIME_ZONE_KEY);
};

export default {
  getCredentials, saveCredentials, destroyCredentials,
  getToken, saveToken, destroyToken,
  getUser, saveUser, destroyUser, getUserHubGroupKey,
  getLanguage, saveLanguage, destroyLanguage,
  saveTimeZone, getTimeZone, destroyTimeZone
};
